import { render, staticRenderFns } from "./auctionTimer.vue?vue&type=template&id=1dfceff6&scoped=true&"
import script from "./auctionTimer.vue?vue&type=script&lang=js&"
export * from "./auctionTimer.vue?vue&type=script&lang=js&"
import style0 from "./auctionTimer.vue?vue&type=style&index=0&id=1dfceff6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfceff6",
  null
  
)

export default component.exports